import styled from '@emotion/styled'

export const H2Highlight = styled.h2`
	color: ${(props) => props.theme.highlightColor};
	text-align: center;
`
